export interface CMSContent {
  seo?: {
    title?: string;
    description?: string;
    ogImage?: string;
    slug?: string;
  };
  hero: {
    title: string;
    subtitle: string;
    cta: string;
    imageUrl?: string;
    link?: string;
    videoUrl?: string;
  };
  showcase: {
    label: string;
    title: string;
    description: string;
    productIds: string[];
  };
  features: {
    title: string;
    description: string;
    items: Array<{
      title: string;
      description: string;
      icon: string;
    }>;
  };
  testimonials: {
    title: string;
    subtitle: string;
    items: Array<{
      name: string;
      role: string;
      content: string;
      avatar: string;
    }>;
  };
  ugc: {
    title: string;
    subtitle: string;
    items: Array<{
      videoUrl: string;
      productId?: string;
      thumbnailUrl?: string;
    }>;
  };
  faq: {
    title: string;
    description: string;
    items: Array<{
      id?: string;
      question: string;
      answer: string;
    }>;
  };
  cta: {
    title: string;
    description: string;
    buttonText: string;
    buttonLink?: string;
    backgroundImageUrl?: string;
    backgroundVideoUrl?: string;
  };
  footer: {
    tagline: string;
    email: string;
    phone: string;
    copyright: string;
    links: Array<{
      id?: string;
      title: string;
      items: Array<{ id?: string; label: string; url: string; isExternal?: boolean }>;
    }>;
    campaignSubtitle?: string;
    campaignTitle?: string;
    campaignCtaText?: string;
    campaignCtaLink?: string;
    instagramUrl?: string;
    tiktokUrl?: string;
    whatsappUrl?: string;
    facebookUrl?: string;
    twitterUrl?: string;
    shopeeUrl?: string;
  };
  marquee: {
    items: string[];
  };
  stylePreference: {
    title: string;
    items: Array<{
      title: string;
      subtitle: string;
      cta: string;
      link: string;
      imageUrl: string;
      videoUrl?: string;
    }>;
  };
  header?: {
    announcement?: {
      enabled: boolean;
      text: string;
      link?: string;
    };
    logo?: {
      lightUrl?: string;
      darkUrl?: string;
      heightPx?: number;
    };
    menuItems: Array<{
      id: string;
      label: string;
      url: string;
      isExternal?: boolean;
    }>;
  };
  global: {
    siteTitle: string;
    seoDescription: string;
    seoKeywords: string;
  };
  notifications: {
    reviewRecipients: string;
  };
}

export const initialCMSContent: CMSContent = {
  header: {
    announcement: {
      enabled: false,
      text: "Gratis Ongkir ke Seluruh Indonesia untuk Setiap Pembelian Hari Ini",
      link: "/shop"
    },
    logo: {
      lightUrl: "",
      darkUrl: "",
      heightPx: 20
    },
    menuItems: [
      { id: "nav-home", label: "Beranda", url: "/" },
      { id: "nav-shop", label: "Koleksi", url: "/shop" },
      { id: "nav-about", label: "Tentang", url: "/about" },
      { id: "nav-careers", label: "Karir", url: "/careers" },
      { id: "nav-blog", label: "Blog", url: "/blog" }
    ]
  },
  hero: {
    title: "Hari spesial, bersama SECERA.",
    subtitle: "Saat momen spesial datang, kamu ingin tampil tepat.",
    cta: "Pilih VERSA untuk Hari Spesial",
    link: "/product/versa",
    imageUrl: "/hero-image.jpg",
    videoUrl: "/uploads/517730be-75ae-48f1-ad0c-535f79799a5c.mp4"
  },
  showcase: {
    label: "Pilihan untuk momen penting",
    title: "Kualitas premium yang terasa personal, saat momen spesial datang, kamu ingin tampil tepat.",
    description: "Koleksi terbaik. Nyaman dipakai. Terlihat berkelas di hari yang kamu tunggu.",
    productIds: ["kala", "versa", "sll", "slw"]
  },
  marquee: {
    items: [
      "Material Premium",
      "Desain Eksklusif",
      "Tampil Instant",
      "Detail Berkualitas",
      "5 Stars Customer Service"
    ]
  },
  features: {
    title: "Mengapa Memilih Secera?",
    description: "Kami mengutamakan kualitas material dan kenyamanan dalam setiap desain.",
    items: [
      {
        title: "Material Premium",
        description: "Menggunakan bahan Ceruty Babydoll kualitas terbaik yang flowy dan nyaman.",
        icon: "Layers"
      },
      {
        title: "Desain Eksklusif",
        description: "Setiap koleksi dirancang dengan detail unik yang tidak akan Anda temukan di tempat lain.",
        icon: "Gem"
      },
      {
        title: "Mudah Dibentuk",
        description: "Karakter bahan yang tegak di dahi dan mudah diatur untuk berbagai gaya.",
        icon: "Sparkles"
      }
    ]
  },
  testimonials: {
    title: "Apa Kata Mereka?",
    subtitle: "Ribuan wanita telah mempercayakan gaya modest mereka pada Secera.",
    items: [
      {
        name: "Sarah Amanda",
        role: "Fashion Enthusiast",
        content: "Bahannya bener-bener premium, flowy banget dan gampang dibentuk. Suka banget sama koleksi warnanya!",
        avatar: ""
      }
    ]
  },
  ugc: {
    title: "Dipakai di Hari Spesial Mereka",
    subtitle: "Inspirasi dari komunitas kami. Tag @secera.id untuk kesempatan tampil di sini.",
    items: [
      {
        videoUrl: "https://www.tiktok.com/@sissy_ms/video/7626709159244860680?shop_region=ID&shop_id=7496238119683525562",
        productId: "sltr",
        thumbnailUrl: ""
      },
      {
        videoUrl: "https://www.tiktok.com/@ptrntsy/video/7616588839976488212?shop_region=ID&shop_id=7496238119683525562",
        productId: "versa",
        thumbnailUrl: ""
      },
      {
        videoUrl: "https://www.tiktok.com/oembed?url=https://www.tiktok.com/@approvedfits/video/7626401822378691860?shop_region=ID&shop_id=7496238119683525562",
        productId: "versa",
        thumbnailUrl: ""
      },
      {
        videoUrl: "https://www.tiktok.com/@wolfiehunney/video/7617654316714822933?shop_region=ID&shop_id=7496238119683525562",
        productId: "sll",
        thumbnailUrl: ""
      },
      {
        videoUrl: "tiktok.com/@diancristina92/video/7631053478567234823?shop_region=ID&shop_id=7496238119683525562",
        productId: "kala",
        thumbnailUrl: ""
      },
      {
        videoUrl: "https://www.tiktok.com/@taffaniadq/video/7624363253723860245?shop_region=ID&shop_id=7496238119683525562",
        productId: "versa",
        thumbnailUrl: ""
      }
    ]
  },
  faq: {
    title: "Sebelum Kamu Checkout",
    description: "Jawaban singkat. Biar kamu pilih dengan yakin.",
    items: [
      {
        id: "faq-1777029756347-1-xlp7hnmct",
        question: "Berapa lama waktu pengiriman?",
        answer: "Pesanan sebelum jam 14:00 akan dikirim di hari yang sama, lalu dikirim sesuai area tujuan. Estimasi akan tampil jelas saat checkout. Namun proses tetap bergantung kepada kecepatan pihak ekspedisi."
      },
      {
        id: "faq-1777029756347-0-z3id4zvdk",
        question: "Apakah bahannya mudah kusut?",
        answer: "Tidak, kami menggunakan material Ceruty Babydoll Premium yang flowy dan tidak mudah kusut. Tetap rapi untuk acara panjang."
      },
      {
        id: "faq-1777951519585",
        question: "Aku bingung pilih gaya.",
        answer: "Mulai dari momenmu. Kami bantu lewat kurasi yang jelas. Hubungi tim SECERA, kapanpun."
      }
    ]
  },
  cta: {
    title: "Penawaran Eksklusif Website",
    description: "Dapatkan potongan harga hingga 15% untuk setiap pembelian langsung melalui website kami hari ini.",
    buttonText: "Mulai Belanja Sekarang",
    buttonLink: "/shop",
    backgroundImageUrl: "/uploads/derived/201bca70-57ab-4b18-801e-1cdb28d9c7c2-w1200.webp",
    backgroundVideoUrl: ""
  },
  stylePreference: {
    title: "Temukan Gaya Anda",
    items: [
      {
        title: "Modern",
        subtitle: "Minimalis & Tegas",
        cta: "Lihat Gaya Modern",
        link: "/shop?style=modern",
        imageUrl: "/uploads/831b86cc-e8e1-4dd3-8fb8-7398084d397d.webp",
        videoUrl: ""
      },
      {
        title: "Etnik",
        subtitle: "Sentuhan Budaya & Anggun",
        cta: "Lihat Gaya Etnik",
        link: "/shop?style=etnik",
        imageUrl: "/uploads/3b00b224-257c-457d-9c36-39f3c3425453.webp",
        videoUrl: ""
      }
    ]
  },
  footer: {
    tagline: "Mendefinisikan ulang gaya modest",
    email: "care@secera.id",
    phone: "62857-5099-0000",
    copyright: "©Copyright 2025 Secera",
    campaignSubtitle: "Dapatkan komisi eksklusif dengan berbagi keanggunan",
    campaignTitle: "BERGABUNG SEBAGAI AFFILIATOR SECERA",
    campaignCtaText: "HUBUNGI WHATSAPP",
    campaignCtaLink: "",
    instagramUrl: "",
    tiktokUrl: "",
    whatsappUrl: "",
    facebookUrl: "",
    twitterUrl: "",
    shopeeUrl: "",
    links: [
      {
        title: "Gaya Pilihan",
        items: [
          { label: "Modern", url: "/shop?style=modern" },
          { label: "Etnik", url: "/shop?style=etnik" }
        ]
      },
      {
        title: "Tentang",
        items: [
          { label: "Tentang Kami", url: "/tentang" },
          { label: "Karir", url: "/karir" },
          { label: "Syarat & Ketentuan", url: "#" }
        ]
      }
    ]
  },
  global: {
    siteTitle: "SECERA | Effortless Occasion Wear",
    seoDescription: "Tampil siap bukan soal waktu yang panjang. SECERA menghadirkan koleksi effortless occasion wear premium—dari selendang instan hingga setelan busana modular.",
    seoKeywords: "fashion, modest, hijab, busana muslim, premium",
  },
  notifications: {
    reviewRecipients: "",
  }
};
